import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import extensions3 from "../../../../assets/images/docs/extension-manager.png";
import formsoutline from "../../../../assets/images/docs/outline/forms.png";
import formsoutlinebad from "../../../../assets/images/docs/outline/forms-bad.png";
import forminspector from "../../../../assets/images/blogs/pp25/forminspector.png";
import extensionsv3 from "../../../../assets/images/blogs/pp25/extensions.png";
import emureset from "../../../../assets/images/blogs/pp25/emureset.png";
import targetsizetoggle from "../../../../assets/images/blogs/pp25/toggle.mp4";
import * as React from 'react';
export default {
  PolypaneIntro,
  ShortCutDisplay,
  extensions3,
  formsoutline,
  formsoutlinebad,
  forminspector,
  extensionsv3,
  emureset,
  targetsizetoggle,
  React
};